import SapBonusPayoutList from "@/pages/admin/sap_bonus_payout/SapBonusPayoutList.vue";
import PayoutList from "@/pages/admin/sap_bonus_payout/PayoutList.vue";
import BonusVarianceReport from "@/pages/admin/sap_bonus_payout/BonusVarianceReport.vue";

const SapBonusPayoutRoutes = [
  {
    path: "sap_bonus_payout",
    name: "app-admin-sap-bonus-payout",
    component: SapBonusPayoutList,
  },
  {
    path: "sap_bonus_payout/payout/:id",
    name: "app-admin-payout-list",
    component: PayoutList,
  },
  {
    path: "sap_bonus_payout/bonus_variance_report",
    name: "app-admin-bonus-variance-report",
    component: BonusVarianceReport,
  },
];

export default SapBonusPayoutRoutes;
